import {getBlockModel} from '../block/block'
import {getBlockShapeModel} from '../block/shape'
import {getBlockIconModel} from '../block/icon'
import {
    MODEL_ENTITY_RULE,
    RULE_EXPRESSION,
    RULE_EXPRESSION_EVALUATE,
    RULE_MATRIX,
    RULE_STATEMENT,
    RULE_STATEMENT_OBJ,
    RULE_TREE,
    RULE_TRUTH_TABLE,
    RULE_VALIDATE_DATA,
    VALIDATE_DATA_TYPE_SIMPLE,
    WORKFLOW_PATH_ERROR,
    WORKFLOW_PATH_FALSE,
    WORKFLOW_PATH_TRUE
} from '../index'

export const workflowRules = Object.freeze({

    [RULE_STATEMENT]: {
        ...getBlockModel(false, 'Statement rule', [
            getBlockShapeModel(),
            getBlockIconModel('cube')
        ], {
            entity: MODEL_ENTITY_RULE,
            key: RULE_STATEMENT,
            description: 'Statement rules are rules that evaluate a statement and either return a true or false outcome within a flow.',
            logic: null,
            objectId: null,

            [WORKFLOW_PATH_TRUE]: null, // block "To" id
            [WORKFLOW_PATH_FALSE]: null // block "To" id
        }, {
            paths: {
                from: {min: 0, max: 3},
                to: {min: 1, max: -1}
            }
        })
    },

    [RULE_STATEMENT_OBJ]: {
        ...getBlockModel(false, 'Statement rule object', [
            getBlockShapeModel(),
            getBlockIconModel('cubes')
        ], {
            entity: MODEL_ENTITY_RULE,
            key: RULE_STATEMENT_OBJ,
            description: 'Statement rules are rules that evaluate a statement and either return a true or false outcome within a flow.',
            logic: null,
            objectId: null,
            result: {}, // result object data

            [WORKFLOW_PATH_TRUE]: null,
            [WORKFLOW_PATH_FALSE]: null
        }, {
            paths: {
                from: {min: 0, max: 3},
                to: {min: 1, max: -1}
            }
        })
    },

    [RULE_EXPRESSION]: {
        ...getBlockModel(false, 'Expression', [
            getBlockShapeModel(),
            getBlockIconModel('lambda')
        ], {
            entity: MODEL_ENTITY_RULE,
            key: RULE_EXPRESSION,
            description: 'This rule allows evaluating an expression and return a true or false outcome within a flow.',
            objectId: null,
            expression: '',

            [WORKFLOW_PATH_TRUE]: null, // block "To" id
            [WORKFLOW_PATH_FALSE]: null // block "To" id
        }, {
            paths: {
                from: {min: 0, max: 3},
                to: {min: 1, max: -1}
            }
        })
    },

    [RULE_EXPRESSION_EVALUATE]: {
        ...getBlockModel(false, 'Evaluate', [
            getBlockShapeModel(),
            getBlockIconModel('equals')
        ], {
            entity: MODEL_ENTITY_RULE,
            key: RULE_EXPRESSION_EVALUATE,
            description: 'This rule allows evaluating an expression and return an object outcome within a flow.',
            objectId: null,
            expression: '',

            [WORKFLOW_PATH_TRUE]: null, // block "To" id
            [WORKFLOW_PATH_FALSE]: null // block "To" id
        }, {
            paths: {
                from: {min: 0, max: 3},
                to: {min: 1, max: -1}
            }
        })
    },

    [RULE_MATRIX]: {
        ...getBlockModel(false, 'Matrix rule', [
            getBlockShapeModel(),
            getBlockIconModel('function')
        ], {
            entity: MODEL_ENTITY_RULE,
            key: RULE_MATRIX,
            description: 'Matrix Rules is a truth table on two axis and can output only one value.',
            tValues: null,
            tConditions: null,
            tResults: null,
            tMatrixHead: null,

            [WORKFLOW_PATH_TRUE]: null,
            [WORKFLOW_PATH_FALSE]: null
        }, {
            paths: {
                from: {min: 0, max: 3},
                to: {min: 1, max: -1}
            }
        })
    },

    [RULE_TREE]: {
        ...getBlockModel(false, 'Tree rule', [
            getBlockShapeModel(),
            getBlockIconModel('tree-alt')
        ], {
            entity: MODEL_ENTITY_RULE,
            key: RULE_TREE,
            description: 'While Matrix Rules have two Axis to establish two parameters, a Tree Rule only has one.',
            tValues: null,
            tConditions: null,
            tResults: null,

            [WORKFLOW_PATH_TRUE]: null,
            [WORKFLOW_PATH_FALSE]: null
        }, {
            paths: {
                from: {min: 0, max: 3},
                to: {min: 1, max: -1}
            }
        })
    },

    [RULE_TRUTH_TABLE]: {
        ...getBlockModel(false, 'Truth table', [
            getBlockShapeModel(),
            getBlockIconModel('table')
        ], {
            entity: MODEL_ENTITY_RULE,
            key: RULE_TRUTH_TABLE,
            description: 'Truth tables are rules that compare the possible combinations of multiple inputs.',
            tHead: null,
            tBody: null,
            tResults: null,

            [WORKFLOW_PATH_TRUE]: null,
            [WORKFLOW_PATH_FALSE]: null
        }, {
            paths: {
                from: {min: 0, max: 3},
                to: {min: 1, max: -1}
            }
        })
    },

    [RULE_VALIDATE_DATA]: {
        ...getBlockModel(false, 'Validate data', [
            getBlockShapeModel(),
            getBlockIconModel('check-circle')
        ], {
            entity: MODEL_ENTITY_RULE,
            key: RULE_VALIDATE_DATA,
            description: 'This rule allows validating data against a set of rules within a flow.',

            objectId: null,
            type: VALIDATE_DATA_TYPE_SIMPLE,

            /**
             * if VALIDATE_DATA_TYPE_SIMPLE:
             * validatorFrontendModel - a model that is easier to work with on the client
             * validator - validatorFrontendModel transformed to validatorjs library format (for the server)
             */
            validatorFrontendModel: [],
            validator: {
                rules: {},
                messages: {}
            },
            // if VALIDATE_DATA_TYPE_ADVANCED
            expression: '',

            [WORKFLOW_PATH_TRUE]: null,
            [WORKFLOW_PATH_FALSE]: null,
            [WORKFLOW_PATH_ERROR]: null
        }, {
            paths: {
                from: {min: 0, max: 3},
                to: {min: 1, max: -1}
            }
        })
    }
})

export const workflowRulesList = Object.freeze(Object.values(workflowRules))

export const workflowRulesOptions = workflowRulesList.map(r => ({name: r.name, key: r.model.key}))
